/**
 * Billing — B2B invoices (BP-04/07). The payment-recording flow now lives in
 * Members→Payments (shared PaymentDialog); the /billing route is B2B-only.
 */
import { type ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

import { Card } from '../../components/ui/Card.js';
import { PageHeader } from '../../components/ui/Layout.js';

import { B2BInvoiceForm } from './B2BInvoiceForm.js';
import { B2BInvoiceList } from './B2BInvoiceList.js';

export function BillingPage(): ReactNode {
  const { t } = useTranslation();

  return (
    <div className="grid gap-5">
      <PageHeader title={t('billing.title')} subtitle={t('billing.subtitle')} />
      <div className="grid gap-5 lg:grid-cols-5">
        <div className="lg:col-span-2">
          <Card className="p-5">
            <B2BInvoiceForm />
          </Card>
        </div>
        <div className="lg:col-span-3">
          <B2BInvoiceList />
        </div>
      </div>
    </div>
  );
}
